import axios from "axios"
import { CELLULE_API_URL } from "../Api-end-points";


export class CelluleService {
    static async fetch() {
        return await axios.get(`${CELLULE_API_URL}`).then((res) => res.data);
    }
}